<template>
  <div>
    <div class="tab-box">
      <div
        style="display:flex;align-items:center"
        v-for="tab in tabs"
        :key="tab.name"
        class="tab"
        :class="{active: tab.id === defaultId}"
        :style="{lineHeight: `${height}px`}"
        :name="tab.id"
        @click="handleClickTab(tab.id)">
        <span>
          {{ tab.name }}
        </span>
        <Tips v-if="tab.tips" :style="{lineHeight: `${height}px`}" :tips="tab.tips" width={200} />
      </div>

    </div>
    <div class="line"></div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default() {
        return []
      }
    },
    tips: String,
    defaultId: {
      type: [String, Number, Boolean]
    },
    height: {
      type: Number,
      default: 40
    },
    fontSize: {
      type: Number,
      default: 14
    }
  },
  model: {
    prop: 'defaultId',
    event: 'change'
  },
  methods: {
    handleClickTab(id) {
      this.$emit('change', id)
      this.$emit('dlPortfolioId')
    }
  }
}
</script>

<style lang="scss" scoped>
.line{
  margin-top: -1px;
  width: 100%;
  height: 1px;
  background-color: #E1E1E1
}
.tab-box{
  display: flex;
  // padding-left: 16px;
}
.tab {
  color: $G9;
  display: inline-block;
  vertical-align: top;
  font-size: 12px;
  padding: 0 16px;
  // margin-right:48px;
  text-align: center;
  cursor: pointer;
  &.active {
    font-weight: 600;
    color: $main-color;
    border-bottom: 2px solid $main-color;
  }
}
</style>
